// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__syTkV","btn_wrap":"Button_btn_wrap__Weyrt","btn_button":"Button_btn_button__p1OjC"};